import { useEffect, useState } from 'react';
import client from './api';

// LMS slice of the MMS points program (MMS_POINTS_HUB_PLAN F4). The MMS owns the
// rules; the LMS only reads "which actions earn what" and the member's own points.
export const pointsAPI = {
  actions: () => client.get('/public/points/actions'),
  mine: () => client.get('/me/points'),
  share: (courseId) => client.post(`/courses/${courseId}/share`),
};

let actionsPromise = null;

// Active LMS actions, fetched once per page load and shared by every caller.
export function useLmsActions() {
  const [actions, setActions] = useState([]);
  useEffect(() => {
    if (!actionsPromise) {
      actionsPromise = pointsAPI.actions()
        .then(({ data }) => data.actions || [])
        .catch(() => { actionsPromise = null; return []; });
    }
    let alive = true;
    actionsPromise.then((a) => { if (alive) setActions(a); });
    return () => { alive = false; };
  }, []);
  return actions;
}

export function pointsFor(actions, trigger) {
  const a = (actions || []).find((x) => x.trigger === trigger);
  return a ? Number(a.points) || 0 : 0;
}
